var _rect, _rect2, _rect3, _rect4, _rect5, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSierCompanyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 96,
    height: 96,
    rx: 8,
    fill: "#F1F0EC",
    stroke: "#1E3A8A",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 55,
    width: 10,
    height: 28,
    fill: "#1E3A8A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 45,
    width: 10,
    height: 38,
    fill: "#1E3A8A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 35,
    width: 10,
    height: 48,
    fill: "#1E3A8A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 82,
    width: 60,
    height: 3,
    fill: "#1E3A8A"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 27,
    fontFamily: "sans-serif",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#1E3A8A",
    textAnchor: "middle"
  }, "SIer")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSierCompanyLogo);
export default __webpack_public_path__ + "static/media/sierCompanyLogo.6551175bdceb3298c7fcc7d1d5c7c9af.svg";
export { ForwardRef as ReactComponent };